import React, { useState } from 'react';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setMessage('Processing...');
        const body = JSON.stringify({ email: email});
       // window.alert(`Request body:\n${body}`);
        try {
            const endpoint = 'https://3rozn3owdc.execute-api.us-east-1.amazonaws.com/Prod/ForgotPassword';
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: body,
            });

            const data = await response.json();
            if (response.ok) {
                setMessage('If this email is registered, a reset link will be sent.');
                // Redirect to dashboard or another page if needed
            } else {
                const error = data;
                setMessage(`Error: ${error.message || response.statusText}`);
            }
        } catch (err) {
            setMessage(`Error: ${err.message}`);
        }
    };

    return (
        <form onSubmit={handleForgotPassword}>
            <h2>Forgot Password</h2>
            <input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} required />
            <button type="submit">Send Reset Link</button>
            <p>{message}</p>
        </form>
    );
}

export default ForgotPassword;
